import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';



@Component({
    selector: 'app-editcustomergroup',
    templateUrl: './editcustomergroup.component.html',
    styleUrls: ['./editcustomergroup.component.scss'],
    standalone: false
})
export class EditcustomergroupComponent extends ModelEditor {

  constructor(injector: Injector,
  ) {
    super("parking/customergroups", injector);
  }

  public override DefaultModel(): any {
    return {
      Name: "",
      Description: "",
      TotalSpaces: 0,
      ReservedSpaces: 0,
      OccupiedSpaces: 0,
      AvailableSpaces: 0
    };
  }

  public override AfterModelLoaded(): void {
    // Any additional logic after model is loaded
  }

  public override BeforeSave(): void {
    // Recalculate available spaces before saving
    const totalSpaces = this.Model.TotalSpaces || 0;
    const occupiedSpaces = this.Model.OccupiedSpaces || 0;
    const reservedSpaces = this.Model.ReservedSpaces || 0;
    
    this.Model.AvailableSpaces = Math.max(0, totalSpaces - occupiedSpaces - reservedSpaces);
  }

  public override Validators(): any {
    return {
      "Name": [Validators.required, Validators.maxLength(128)],
      "Description": [Validators.maxLength(512)],
      "TotalSpaces": [Validators.required, Validators.min(0)],
      "ReservedSpaces": [Validators.min(0)]
    };
  }


} 
